// ============================================================
// SUPABASE SCHEMA REFERENCE
// When connecting to Supabase, create these tables with the
// following exact column structure:
//
// supabase table: members
//   columns: id uuid, nombre text, apellido text, curp text unique,
//            telefono text, email text unique, fecha_nacimiento date,
//            estado_residencia text, ciudad text, folio text unique,
//            plan text, plan_precio integer, fecha_contratacion date,
//            fecha_carencia_fin date, estado text default 'carencia',
//            created_at timestamp.
//
// supabase table: beneficiarios
//   columns: id uuid, member_id uuid references members,
//            nombre text, parentesco text, curp text nullable,
//            fecha_nacimiento date, estado text default 'carencia',
//            fecha_carencia_fin date, created_at timestamp.
//
// supabase table: pagos
//   columns: id uuid, member_id uuid references members,
//            mes text, monto integer, fecha_pago date nullable,
//            metodo_pago text, estado text, created_at timestamp.
// ============================================================

export const COVERLY_WHATSAPP = '526675680042';
export const COVERLY_PHONE = '526675680042';

export const mockUser = {
  id: 'USR-001',
  nombre: 'Enrique',
  apellido: 'Salazar',
  nombreCompleto: 'Enrique Salazar Osuna',
  curp: 'SAOE920126HSLSLR01',
  telefono: '+52 667 123 4567',
  email: 'enrique@coverly.mx',
  ciudad: 'Culiacán',
  estado_residencia: 'Sinaloa',
  folio: 'CVR-2025-0001',
  plan: 'familiar',
  planNombre: 'Basico',
  planPrecio: 289,
  fechaContratacion: '2025-01-15',
  fechaCarenciaFin: '2025-04-15',
  estado: 'carencia',
  diasRestantesCarencia: 45,
};

export const mockBeneficiarios = [
  {
    id: 'BEN-001',
    nombre: 'Rosa Salazar Osuna',
    parentesco: 'Madre',
    curp: 'SAOR650310MSLSLR02',
    estado: 'carencia',
    iniciales: 'RS',
    fechaCarenciaFin: '2025-04-15',
  },
  {
    id: 'BEN-002',
    nombre: 'Pedro Salazar Osuna',
    parentesco: 'Padre',
    curp: 'SAOP620820HSLSLR03',
    estado: 'activa',
    iniciales: 'PS',
    fechaCarenciaFin: null,
  },
];

export const mockPagos = [
  {
    id: 'PAY-001',
    mes: 'Enero 2025',
    monto: 289,
    fecha: '2025-01-15',
    estado: 'pagado',
  },
  {
    id: 'PAY-002',
    mes: 'Febrero 2025',
    monto: 289,
    fecha: '2025-02-15',
    estado: 'pagado',
  },
  {
    id: 'PAY-003',
    mes: 'Marzo 2025',
    monto: 289,
    fecha: '2025-03-15',
    estado: 'pagado',
  },
  {
    id: 'PAY-004',
    mes: 'Abril 2025',
    monto: 289,
    fecha: null,
    estado: 'pendiente',
  },
];

export const beneficiosFamiliar = [
  'Velación en domicilio o funeraria a elección',
  'Carpa 3x3m, 80 sillas, 4 cirios y pedestal en domicilio',
  'Ataúd metálico o de madera Nivel 1',
  'Cafetería estándar',
  'Arreglo estético y embalsamamiento',
  'Transporte en carroza clásica hasta 100km',
  'Velación hasta 24 horas',
  'Asesoría en trámites legales',
];

export const beneficiosPlus = [
  'Velación en domicilio o funeraria a elección',
  'Carpa 3x3m, 80 sillas, 4 cirios y pedestal en domicilio',
  'Ataúd metálico o de madera Nivel 1',
  'Cafetería estándar',
  'Arreglo estético y embalsamamiento',
  'Transporte en carroza clásica hasta 100km',
  'Velación hasta 24 horas',
  'Asesoría en trámites legales',
  'Ataúd metálico o de madera Nivel 2',
  'Urna clásica o ecológica incluida',
  'Opcion de agregar cremacion a la membresia',
];

export const parentescos = [
  'Cónyuge',
  'Hijo/a',
  'Padre',
  'Madre',
  'Hermano/a',
  'Abuelo/a',
  'Otro familiar',
];

export const estados = [
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Ciudad de México',
  'Coahuila',
  'Colima',
  'Durango',
  'Guanajuato',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'Estado de México',
  'Michoacán',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Querétaro',
  'Quintana Roo',
  'San Luis Potosí',
  'Sinaloa',
  'Sonora',
  'Tabasco',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz',
  'Yucatán',
  'Zacatecas',
];
